export default __webpack_public_path__ + "static/media/Antillian Leggings.1c185cec.jpg";